import { Injectable } from '@angular/core';
import { Titles } from '../../config/titles';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  public pageTitle: string;

  constructor(private titles: Titles) {}

  setPageTitle(route) {
    this.pageTitle = this.titles.titles[route];
  }
}
